import React from "react";

const MaterialBreakdownCEA = ({ quotationType = null }) => {
  let serial = 1;

  return (
    <div>
      <h3 className="table-heading">
        Material Breakdown (For Exports Custom BoM):
      </h3>
      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td style={{ width: "50%" }}>
              <table style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th style={{ width: "5%" }}>Sr.</th>
                    <th style={{ width: "65%" }}>Particulars</th>
                    <th style={{ width: "15%" }}>HSN</th>
                    <th style={{ width: "15%" }}>GST</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td> {serial++}.</td>
                    <td>GI 60OD X 2.0 X 1.0</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI 76OD X 2.0 X 6.5</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI 76OD X 2.0 X 6.5</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI 76OD X 2.0 X 4.5</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI 60OD X 2.0 X 8</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI 60OD X 2.0 X 8</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI 48OD X 2.0 X 4</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI 60OD X 2.0 X 5.5</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI 60OD X 2.0 X 2</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI 42OD X 2.0 X 1</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI 42OD X 2.0 X 4</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI 42OD X 2.0 X 6</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI 42OD X 2.0 X 4.5</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI 33OD X 2.0 X 5</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI 33OD X 2.0 X 4</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI 33OD X 2.0 X 2</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI 33OD X 2.0 X 1.5</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI 33OD X 2.0 X 2</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI 33OD X 2.0 X 2.5</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI 33OD X 2.0 X 1</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI 27OD X 2.0 X 6</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI 27OD X 2.0 X 3</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI 42OD X 2.0 X 5.2</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI pipe 42OD X 2.0 X 4</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI pipe 42OD X 2.0 X 6</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI gutter</td>
                    <td>72104900</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>Fixture pipe</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>Angle bracket</td>
                    <td>72162100</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>76OD full clamp</td>
                    <td>73084000</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>76OD half clamp</td>
                    <td>73084000</td>
                    <td>18%</td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td style={{ width: "50%" }}>
              <table style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th style={{ width: "5%" }}>Sr.</th>
                    <th style={{ width: "65%" }}>Particulars</th>
                    <th style={{ width: "15%" }}>HSN</th>
                    <th style={{ width: "15%" }}>GST</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{serial++}.</td>
                    <td>60OD full clamp</td>
                    <td>73084000</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>60OD half clamp</td>
                    <td>73084000</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>42OD full clamp</td>
                    <td>73084000</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>42OD half clamp</td>
                    <td>73084000</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>Bolts + Nuts</td>
                    <td>73181900</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>Self screw</td>
                    <td>73181500</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI profile</td>
                    <td>00007212</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>Spring</td>
                    <td>00007212</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>Shade net pully</td>
                    <td>00007212</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>Shade net Joiner</td>
                    <td>00730630</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>TUF nylon ropes</td>
                    <td>00730630</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>Ring hooks</td>
                    <td>83023090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>Curtain clamp 3/4</td>
                    <td>73084000</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>Universal joint</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>Curtain pipe inset</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>Curtain & flap inset</td>
                    <td>73063090</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>FRP door</td>
                    <td>70191100</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>Door section 12FT</td>
                    <td>76042910</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>Door handle & hinge</td>
                    <td>87089900</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI Wire 14G</td>
                    <td>00007214</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>Binding wire</td>
                    <td>72179099</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>G-Fab apron</td>
                    <td>39269099</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>Polyfilm white</td>
                    <td>39209999</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>Insect net</td>
                    <td>54077300</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>Tape net</td>
                    <td>60059000</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>GI funnel</td>
                    <td>72104900</td>
                    <td>18%</td>
                  </tr>

                  {quotationType !== "nvph" && quotationType !== "fanpad" && (
                    <tr>
                      <td>{serial++}.</td>
                      <td>Fogger assembly</td>
                      <td>84249000</td>
                      <td>18%</td>
                    </tr>
                  )}
                  {quotationType !== "nvph" && quotationType !== "fanpad" && (
                    <tr>
                      <td>{serial++}.</td>
                      <td>Fogger motor</td>
                      <td>84249000</td>
                      <td>18%</td>
                    </tr>
                  )}
                  <tr>
                    <td>{serial++}.</td>
                    <td>Air circulation fans (Optional)</td>
                    <td>00841459</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td>{serial++}.</td>
                    <td>Connecting wire</td>
                    <td>72179099</td>
                    <td>18%</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div>
    </div>
  );
};

export default MaterialBreakdownCEA;
